var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOurstory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_473",
    x: 0,
    y: 0,
    width: 134,
    height: 134,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#004869",
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#074673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79a8cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41a1c8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3112",
    "data-name": "Group 3112",
    transform: "translate(-103 -5484.109)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 103, 5484.11)",
    filter: "url(#Ellipse_473)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_473-2",
    "data-name": "Ellipse 473",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(33 24)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3082",
    "data-name": "Group 3082",
    transform: "translate(154 5525.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M25.216,33.258c0-.051,0-.1,0-.151L12.444,30.7a6.386,6.386,0,1,1-6.059-8.408l.151,0L8.516,9.933a5.059,5.059,0,1,1,6.4-5.249l15.606-.133a3.77,3.77,0,1,1,3.714,3.12h-.014L32.085,27.995a5.451,5.451,0,1,1-6.869,5.263Zm.32-1.844a5.452,5.452,0,0,1,1.228-1.959L20.17,20.589,12.139,25.9a6.361,6.361,0,0,1,.632,2.773q0,.165-.008.329Zm2.449-3.2-2.8-7.973a3.805,3.805,0,0,1-.49.032,3.756,3.756,0,0,1-2.547-.991l-.543.359Zm1.713-.317a5.471,5.471,0,0,1,.673-.078L32.528,7.266l-.055-.028-4.768,6.991a3.769,3.769,0,0,1-.9,5.4Zm-18.51-3.428,7.952-5.26-7.12-9.571a5.027,5.027,0,0,1-1.789.468l-2,12.457A6.389,6.389,0,0,1,11.189,24.466Zm9.39-6.211.6-.4a3.778,3.778,0,0,1,.037-2.8l-6.739-5Zm1.647-4.6a3.773,3.773,0,0,1,4.148-.533L31.05,6.269l-16.309.14a5.03,5.03,0,0,1-.557,1.283Z",
    transform: "translate(0 0)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurstory);
export default __webpack_public_path__ + "static/media/ourstory.776aab542f6d32c1782d4c59e07e8a2d.svg";
export { ForwardRef as ReactComponent };